module.exports = __webpack_public_path__ + "img/7_79.07988b7f.png";